import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CalendarIcon } from 'lucide-react';
export function AppointmentCTA() {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const headingY = useTransform(scrollYProgress, [0, 1], ['30px', '-30px']);
  return <section ref={ref} className="py-32 bg-schwarz relative overflow-hidden" data-id="element-18">
      {/* Floating Gold Orbs */}
      <div className="gold-glow-orb w-96 h-96 top-0 right-0 opacity-10" data-id="element-19" />
      <div className="gold-glow-orb w-80 h-80 bottom-0 left-0 opacity-10" style={{
      animationDelay: '-4s'
    }} data-id="element-20" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-21">
        <motion.h2 style={{
        y: headingY,
        willChange: 'transform'
      }} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-5xl md:text-6xl font-poppins font-bold text-weiss mb-8 uppercase tracking-tight" data-id="element-22">
          Vereinbaren Sie Ihren Termin
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl text-gray-light font-lora mb-12 max-w-2xl mx-auto" data-id="element-23">
          Unser Team ist für alle Patienten und Patientinnen, auch aus Fürth und
          Erlangen, mit schnellen Terminen da.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-8" data-id="element-24">
          <Link to="/kontakt" data-id="element-25">
            <button className="btn-gold-hover flex items-center space-x-3 border-2 border-gold text-gold px-10 py-5 font-poppins font-bold uppercase tracking-widest" data-id="element-26">
              <CalendarIcon className="w-5 h-5" data-id="element-27" />
              <span data-id="element-28">Termin vereinbaren</span>
            </button>
          </Link>

          <span className="text-gray-medium font-lora italic" data-id="element-29">oder</span>

          <a href="tel:091156836360" className="text-2xl text-weiss hover:text-gold transition-colors font-poppins font-bold" data-id="element-30">
            0911-56 83 63 60
          </a>
        </motion.div>
      </div>
    </section>;
}